export const TRIGGER_EVT = "toggleTrigger";
export const TOGGLE_EVT = "toggle";
